<template>
  <v-app id="inspire">
    <v-sheet height="600px" align="center" color="deep-white" justify="center" light v-if="validSubDomain">
      <!-- color="#F5F5F5"-->
      <img v-if="institution.logo_url" :src="institution.logo_url" :alt="institution.accronym" height="120"
        style="margin-top: 30px">
      <img v-else src="images/logo_schooltry.png" alt="school-try-logo" height="120" style="margin-top: 30px">
      <v-container light>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-card flat class="mt-n3 px-5 pb-0" width="850" color="darken-2">
              <h3 class="text-center pb-n2 pt-2 font-weight-bold institution_name" :style="`color:${primaryColor}`">
                {{ institution.name }}</h3>
                <h4  class="text-center pb-n2 pt-2 font-weight-bold institution_name"
                    :style="`color:${primaryColor}`">
                    {{institute ? institute.name : "" }}
                </h4>
              <h5 class="text-center pt-n2 pb-1 font-weight-bold">Applicant Portal</h5>
            </v-card>

            <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-for="deadline in general_admission_acceptance_deadlines"
              :key="deadline.admission_round_title">
              <v-card flat class="mt-n3 px-5 pb-n10" width="850" color="darken-2">
                <marquee behavior="scroll" direction="left" scrollamount="5"
                  style="color:red; font-size: 20px; font-weight: bold; margin-top: 10px; margin-bottom: 10px;">
                  <span class="text-center pb-n2 pt-2 font-weight-bold">Acceptance deadline for {{
                    deadline.admission_round_title }} is {{ deadline.general_deadline }} </span>
                </marquee>
              </v-card>

            </v-col>
          </v-col> 
        </v-row>
        <v-divider class="mx-5 mt-2 mb-5"></v-divider>
        <v-row class="mx-n5">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card flat class="mt-n3 px-5 pb-n10" width="400" color="darken-2">
                  <h4 class="text-center pb-n2 pt-2 font-weight-bold"> Navigation Guide</h4>
                  <!-- <h6 class="text-center pt-n2 pb-n4">Please read the following instructions to navigate around the portal.</h6> -->
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-container>
                  <v-card flat class="px-n15 mx-n5 pb-5 mt-n10 pt-n1" width="400" color="gray">
                    <v-row class="px-n5 pb-n15">
                      <v-col cols="12" md="12" class="pb-n10">
                        <!--create bulletted list of instructions-->
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">1. ENROLL</v-list-item-title>
                            <h6 style="text-align: justify;">Click on "ENROLL" to create an account as a new applicant.
                            </h6>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">2. SIGN IN</v-list-item-title>
                            <h6 style="text-align: justify;">Sign in with the login credentials sent to you by email to
                              continue with your application.</h6>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item-title class="font-weight-bold">Technical support:</v-list-item-title>
                        <h6 style="text-align: center;" > {{ support_info }}</h6>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
          <v-divider class="mx-n16" style="height:auto" vertical></v-divider>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card flat class="mt-n3 px-5 pb-n10" width="400" color="darken-2">
                  <v-card-actions class="justify-end py-5">
                    <v-row class="px-2">
                      <v-col cols="12" md="12">
                        <v-btn class="primary font-weight-bold" 
                          @click.prevent="switchComponent('Applicant Enroll')" block>Enroll</v-btn>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-btn class="primary font-weight-bold"   @click.prevent="switchComponent('Resolve Applicant Pre-Admission Fee Payment Claim')" block>Confirm your payment</v-btn>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-btn class="primary font-weight-bold" 
                          @click.prevent="switchComponent('Home')" block>Sign In</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
             
            </v-row>
          </v-col>
        </v-row>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="60"></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-sheet>

  </v-app>
</template>


<script>
import InstituteAPI from "../../../../../apis/Institute";
import InstitutionAPI from "../../../../../apis/Institution";
import UserAPI from "../../../../../apis/User";
import SupportAPI from "../../../../../apis/Support";

export default {
  name: "ApplicantLogin",
  data() {
    return {
      current_institution_id: null,
      // support_info: "Not available yet, contact admin",
      support_info: "",
      show: false,
      overlay: false,
      general_admission_acceptance_deadlines: '',
      admission_round_info: '',
      valid: false,
      primaryRoleName: '',
      nextRouteName: '',
      validCredentials: true,
      institution: null,
      institute: [],
      validSubDomain: false,
      invalidSubDomain: false,
      loading: true,
      primaryColor: this.$vuetify.theme.themes.light.primary,
      loginForm: {
        email: '',
        password: '',
      },
      errors: [],
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'A valid e-mail address required.'
        },
      },
    }
  },

  watch: {
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 5000)
    },
  },

  created() {
    this.institute_acronym = this.$route.params?.acronym;
    if(this.institute_acronym){
        this.getInstitute(this.institute_acronym);
    }
    this.verifySubdomain();
    this.getGeneralAcceptanceFeeDeadline();
  },

  mounted(){    
    // const storedInstitute = sessionStorage.getItem('institute');
    // this.institute = JSON.parse(storedInstitute);
  },

  methods: {
    login() {
      this.overlay = true;
      UserAPI.preAdmissionLogin(this.loginForm)
        .then(response => {
          /**
           * save auth user data in storage for use in other components
           */
          this.userStore.setUser(response.data.data);
          this.userStore.setRoleNames(response.data.data.role_names);
          this.userStore.setPermissionNames(response.data.data.permission_names);
          this.userStore.setSubdomain(response.data.data.institution.subdomain);

          //store tertiary_token in local storage

          let primaryRole = response.data.data.roles[0];
          this.primaryRoleName = primaryRole.type === "Admin" || primaryRole.name === "Staff" ? "Admin" : primaryRole.name;
          this.setNextRouteName(this.primaryRoleName);
          console.log(this.primaryRoleName + " : " + this.nextRouteName)
          this.switchComponent(this.nextRouteName);
        })
        .catch(error => {
          this.overlay = false;
          console.log(error)
          if (error.response.status === 422) {
            this.validCredentials = false;
            this.errors = error.response.data.errors;
          }
        });
    },

    getInstitute(){
      this.overlay = true;
      InstituteAPI.getInstituteByAcronym(this.institute_acronym)
      .then((response) => {
          this.institute = response.data;
          const instituteString = JSON.stringify(this.institute);
          // Store the institute value in session storage
          sessionStorage.setItem('institute', instituteString);
      })
      .catch((error) => {
          console.log(error);
      })
      .finally(() => {
          this.overlay = false;
      });
    },

    /***
     * This method tries to  the existence the url subdomain in db.
     * if the subdomain does not exist, user is redirected to the default login page.
     * if the subdomain is found, the institution's info is fetched from the db to customise the login page.
     */
    verifySubdomain() {
      this.overlay = true;
      InstitutionAPI.verifySubdomain()
        .then(response => {
          this.loading = false;
          this.institution = response.data.institution;
          this.current_institution_id = response.data.institution['id'];
          this.initialize();

          this.acceptance_fee_deadline = response.data.acceptance_fee_due_date;
          this.invalidSubDomain = false;
          this.validSubDomain = true;
        })
        .catch(error => {
          this.validSubDomain = false
          this.invalidSubDomain = true;
          this.$router.push({ name: 'Page Not Found' });
        }).finally(() => { this.overlay = false; });
    },

    initialize() {
      let institution_id = this.current_institution_id;

      SupportAPI.getInstitutionSupportInfo(institution_id).then(
                (response) => {
                    this.support_info = response.data.text;
                }
            );
    },
    // get acceptance fee deadline from InstitutionAPI
    getGeneralAcceptanceFeeDeadline() {
      this.overlay = true;
      InstitutionAPI.getOpenedAdmissionGeneralAcceptanceDeadlines()
        .then(response => {
          this.general_admission_acceptance_deadlines = response.data.general_deadlines;
        })
        .catch(error => {
          console.log(error)
        }).finally(() => { this.overlay = false; });
    },

    switchComponent(comp) {
      this.$router.push({ 
        name: comp,
      });
    },

    setNextRouteName(role) {
      let $userRole = role.trim();
      switch ($userRole) {
        case "Admin":
        case "Super Admin":
          this.nextRouteName = "Admin"
          break;
        case "Lecturer":
          this.nextRouteName = "Lecturer"
          break;
        case "Student":
          this.nextRouteName = "Student"
          break;
        case "Candidate":
          this.nextRouteName = "Private Candidate Application"
          break;
        default:
          this.nextRouteName = "Login";
      }
    }
  },
}
</script>
<style></style>

